import api from '../services/api';

export const exportToCSV = async (endpoint: string, filename: string) => {
  try {
    const response = await api.get(endpoint, {
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    return { success: true };
  } catch (error: any) {
    console.error('Export error:', error);
    throw new Error(error.response?.data?.error?.message || 'Échec de l\'export');
  }
};

export const downloadTemplate = async () => {
  try {
    const response = await api.get('/api/reports/template/declaration', {
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', 'modele_declaration_bilan_social.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    return { success: true };
  } catch (error: any) {
    console.error('Template download error:', error);
    throw new Error('Échec du téléchargement du modèle');
  }
};

export const formatDate = (dateString: string) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('fr-GN', {
    style: 'currency',
    currency: 'GNF'
  }).format(amount);
};

export const getStatusColor = (status: string) => {
  const colors: { [key: string]: string } = {
    'draft': 'bg-gray-100 text-gray-800',
    'pending': 'bg-yellow-100 text-yellow-800',
    'validated': 'bg-green-100 text-green-800',
    'rejected': 'bg-red-100 text-red-800',
    'active': 'bg-green-100 text-green-800',
    'inactive': 'bg-gray-100 text-gray-800',
    'suspended': 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const getStatusLabel = (status: string) => {
  const labels: { [key: string]: string } = {
    'draft': 'Brouillon',
    'pending': 'En attente',
    'validated': 'Validée',
    'rejected': 'Rejetée',
    'active': 'Actif',
    'inactive': 'Inactif',
    'suspended': 'Suspendu'
  };
  return labels[status] || status;
};
